import { cn } from "@/utils/cn";
import { fieldInputClass, fieldInputErrorClass } from "./fieldStyles";

type Props = {
  id: string;
  label: string;
  value: unknown;
  onChange: (v: string) => void;
  error?: string;
  note?: string;
};

export function FieldDate({ id, label, value, onChange, error, note }: Props) {
  const str = typeof value === "string" ? value : "";
  return (
    <div className="mb-6">
      <label htmlFor={id} className="choice-textarea-label">
        {label}
        {note && <span className="choice-group__hint"> {note}</span>}
      </label>
      <input
        id={id}
        type="date"
        className={cn(fieldInputClass, "max-w-xs", error && fieldInputErrorClass)}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? `${id}-error` : undefined}
        value={str}
        onChange={(e) => onChange(e.target.value)}
      />
      {error && <p id={`${id}-error`} className="choice-group__error" role="alert">{error}</p>}
    </div>
  );
}
